import { combineReducers } from 'redux';

import Authenticate from './authenticate/reducers';
import Conversation from './Conversations/reducers';

export default combineReducers({
  Authenticate,
  Conversation,
});
